import '../../App.css';
import * as React from 'react';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StudentDetails from "../Dashboard/studentDetails/page";
import AddressDetails from "../Dashboard/addressDetails/page";
import PhotoSignDetails from "../Dashboard/photoAndSignDetails/page";
import DocumentDetails from "../Dashboard/documentDetails/page";
import CouresChoiceDetails from "../Dashboard/coursechoiceDetails/page";
import SubjectDetails from "../Dashboard/subjectDetails/page";
import PaymentDetails from "../Dashboard/paymentDetails/page";
import ConfirmRegistration from "../Dashboard/confirmregistration/page";
import LastQualifyingExam from '../Dashboard/lastqualifyingexam/page';
import {
    ThumbUpAlt as ThumbUpAltIcon,
    LocalLibrary as LocalLibraryIcon,
    School as SchoolIcon,
    Person as PersonIcon,
    LocationOn as LocationOnIcon,
    PhotoCamera as PhotoCameraIcon,
    Description as DescriptionIcon,
    Assignment as AssignmentIcon,
    Subject as SubjectIcon,
    AttachMoney as AttachMoneyIcon,
    CheckCircle as CheckCircleIcon,
} from '@mui/icons-material';
import { Box, Container, Button } from '@mui/material';
import { useEffect, useState } from 'react';
import { getStudentApplicationByStudent, getAssignedTabs, getAssignedDocuments, postStudentDetails, getRegisterFees, getStudentDetails, createStudentApplication, getStudentApplicationByCourse, UpdateStudentDetails } from "../api/studentDetails"
import PrintApplication from '../PrintApplication/page';
import { Card, CardBody, Col, Row } from 'react-bootstrap';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"

function StudentDashboard({ closedCourses = [] }) {
    console.log("closedCourses in Studnet dashboard=", closedCourses);
    const [activeStep, setActiveStep] = React.useState(0);
    const [completedSteps, setCompletedSteps] = React.useState([]);
    const [registrationFees, setRegistrationFees] = useState("")
    const [errors, setErrors] = useState({
        studentDetails: {},
        addressDetails: {},
        courseDetails: {}
    });
    const [steps, setSteps] = React.useState([
        { label: 'Personal Details', icon: <PersonIcon /> },
        { label: 'Address Details', icon: <LocationOnIcon /> },
        { label: 'Photo and Signature', icon: <PhotoCameraIcon /> },
        { label: 'Course Choice', icon: <SchoolIcon /> },
        { label: 'Confirm Registration', icon: <ThumbUpAltIcon /> },
    ]);
    const studentId =
        typeof window !== "undefined" ? localStorage.getItem("id") : null;
    const token =
        typeof window !== "undefined" ? localStorage.getItem("token") : null;
    const [formData, setFormData] = useState({
        genderid: [],
        religionid: [],
        nationalityid: [],
        casteid: [],
        maritalid: [],
        bloodgroupid: [],
        categorytypeid: [],
        courseid: [],
        countryid: [],
        stateid: [],
        cityid: [],
        selectedCourse: "",
        selectedCaste: "",
        selectedNationality: "",
        selectedGender: "",
        selectedReligion: "",
        selectedMaritalstatus: "",
        selectedBloodGroup: "",
        firstName: "",
        middleNameunicode: "",
        abcid: "",
        selectedNationality: "",
        birthPlace: "",
        udiseno: "",
        middleName: "",
        lastNameunicode: "",
        mobile: "",
        selectedReligion: "",
        selectedMaritalstatus: "",
        lastName: "",
        nameAsPerAdhar: "",
        email: "",
        selectedCasteCategory: "",
        selectedBloodGroup: "",
        firstNameUnicode: "",
        adharCard: "",
        selectedGender: "",
        dateOfBirth: "",
        selectedCategoryType: "",
        exServicemen: false,
        inhouseStudent: false,
        areYouOrphanStudent: false,
        socialReservation: false,
        differentlyAbledStudent: false,

        fatherName: "",
        totalFamilyMember: "",
        fatherNameUnicode: "",
        familyAnnualIncome: "",
        MotherName: "",
        motherNameUnicode: "",
        parentMobile: "",
        ParentName: "",

        permanent: {
            selectedCountry: "",
            selectedState: "",
            selectedCity: "",
            selectedCountry: "",
            selectedState: "",
            selectedCity: "",
            permanentPinCode: "",
            permanentTaluka: "",
            permanentAddress: "",
        },

        temporary: {
            sameAsPermanent: false,
            country: "",
            state: "",
            city: "",
            currentAddress: "",
            currentTaluka: "",
            currentPinCode: "",
        },
    });
    const [isTermsAccepted, setIsTermsAccepted] = useState(false);
    const [applications, setApplications] = useState([]);
    const [isEditMode, setIsEditMode] = useState(false);

    const validateField = (fieldName, value) => {
        const fieldValidations = {
            mobile: value => {
                if (!/^\d{10}$/.test(value)) return 'Mobile No. must be 10 digits';
                return '';
            },
            email: value => {
                if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) return 'Invalid email format';
                return '';
            },
            adharCard: value => {
                if (!/^\d{12}$/.test(value)) return 'Adhar No. must be 12 digits';
                return '';
            },
            abcid: value => {
                if (!/^\d{12}$/.test(value)) return 'ABC Id must be 12 digits';
                return '';
            },
            birthPlace: value => {
                if (!/^[A-Za-z\s]+$/.test(value)) return 'Invalid ABC Id format';
                return '';
            },
            udiseno: value => {
                if (!/^\d{11}$/.test(value)) return 'UDISE No must be 12 digits';
                return '';
            },
            firstName: value => {
                if (!/^[A-Za-z\s]+$/.test(value)) return 'Only alphabets are allowed';
                return '';
            },
            lastName: value => {
                if (!/^[A-Za-z\s]+$/.test(value)) return 'Only alphabets are allowed';
                return '';
            },
            middleName: value => {
                if (!/^[A-Za-z\s]+$/.test(value)) return 'Only alphabets are allowed';
                return '';
            },
            lastNameunicode: value => {
                if (!/^[A-Za-z\s]+$/.test(value)) return 'Only alphabets are allowed';
                return '';
            },
            middleNameunicode: value => {
                if (!/^[A-Za-z\s]+$/.test(value)) return 'Only alphabets are allowed';
                return '';
            },
            firstNameUnicode: value => {
                if (!/^[A-Za-z\s]+$/.test(value)) return 'Only alphabets are allowed';
                return '';
            },
            nameAsPerAdhar: value => {
                if (!/^[A-Za-z\s]+$/.test(value)) return 'Only alphabets are allowed';
                return '';
            },
            fatherName: value => {
                if (!/^[A-Za-z\s]+$/.test(value)) return 'Only alphabets are allowed';
                return '';
            },
            fatherNameUnicode: value => {
                if (!/^[A-Za-z\s]+$/.test(value)) return 'Only alphabets are allowed';
                return '';
            },
            MotherName: value => {
                if (!/^[A-Za-z\s]+$/.test(value)) return 'Only alphabets are allowed';
                return '';
            },
            motherNameUnicode: value => {
                if (!/^[A-Za-z\s]+$/.test(value)) return 'Only alphabets are allowed';
                return '';
            },
            totalFamilyMember: value => {
                if (!value) return 'Total Family Members is required';
                if (!/^\d+$/.test(value)) return 'Only numbers are allowed';
                if (parseInt(value) <= 0) return 'Must be greater than 0';
                return '';
            },
            familyAnnualIncome: value => {
                if (!value) return 'Family Annual Income is required';

                // Remove commas and check if it's a valid number
                const numericValue = value.replace(/,/g, '');
                if (!/^\d+$/.test(numericValue)) return 'Only numbers are allowed';
                if (parseInt(numericValue) <= 0) return 'Must be greater than 0';
                return '';
            },
            ParentName: value => {
                if (!/^[A-Za-z\s]+$/.test(value)) return 'Only alphabets are allowed';
                return '';
            },
            parentMobile: value => {
                if (!/^\d{10}$/.test(value)) return 'Mobile No. must be 10 digits';
                return '';
            },

        };

        return fieldValidations[fieldName] ? fieldValidations[fieldName](value) : '';
    };

    const handleChange = (section, name, value) => {
        // First update the form data
        if (section) {
            setFormData(prevFormData => ({
                ...prevFormData,
                [section]: {
                    ...prevFormData[section],
                    [name]: value
                }
            }));
        } else {
            setFormData(prevFormData => ({
                ...prevFormData,
                [name]: value
            }));
        }
        if (activeStep === 0) {
            const errorMsg = validateField(name, value);
            setErrors(prev => ({
                ...prev,
                studentDetails: {
                    ...prev.studentDetails,
                    [name]: errorMsg
                }
            }));
        }
    };
    const [documents, setDocuments] = useState([]);

    useEffect(() => {
        const fetchStudentDetails = async () => {
            if (!studentId) return;
            try {
                const response = await getStudentDetails(token, studentId);
                if (response.status === 200) {
                    const studentData = response.data;
                    console.log("Fetched Student Date:", studentData)
                    setIsEditMode(true);
                    setFormData((prevFormData) => ({
                        ...prevFormData,
                        firstName: studentData.firstName || '',
                        middleNameunicode: studentData.middleNameUnicode || '',
                        abcid: studentData.abcid || '',
                        selectedGender: studentData.selectedGender || '',
                        selectedReligion: studentData.selectedReligion || '',
                        selectedCasteCategory: studentData.selectedCasteCategory || '',
                        firstName: studentData.firstName || '',
                        middleName: studentData.middleName || '',
                        lastName: studentData.lastName || '',
                        firstNameUnicode: studentData.firstNameUnicode || '',
                        middleNameUnicode: studentData.middleNameunicode || '',
                        lastNameunicode: studentData.lastNameUnicode || '',
                        nameAsPerAdhar: studentData.nameAsPerAadhaar || '',
                        adharCard: studentData.aadhaarCardNo || '',
                        abcid: studentData.abcID || '',
                        mobile: studentData.mobileNo || '',
                        email: studentData.email || '',
                        selectedGender: studentData.gender.id || '',
                        selectedNationality: studentData.nationality.id || '',
                        selectedReligion: studentData.religion.id || '',
                        selectedCasteCategory: studentData.casteCategory.id || '',
                        dateOfBirth: studentData.dateOfBirth || '',
                        birthPlace: studentData.birthPlace || '',
                        selectedMaritalstatus: studentData.maritalStatus.id || '',
                        selectedBloodGroup: studentData.bloodGroup.id || '',
                        selectedCategoryType: studentData.categoryType || '',
                        udiseno: studentData.udiseNo || '',

                        socialReservation: studentData.socialReservation === true,
                        inhouseStudent: studentData.inHouse === true,
                        exServicemen: studentData.exServicemenStudent === true,
                        differentlyAbledStudent: studentData.differentlyAbled === true,
                        areYouOrphanStudent: studentData.orphan === true,
                        fatherName: studentData.fatherName || '',
                        fatherName: studentData.fatherName || '',
                        fatherNameUnicode: studentData.fatherNameUnicode || '',
                        MotherName: studentData.motherName || '',
                        motherNameUnicode: studentData.motherNameUnicode || '',
                        totalFamilyMember: studentData.familyMembers || '',
                        familyAnnualIncome: studentData.annualIncome || '',
                        ParentName: studentData.parentName || '',
                        parentMobile: studentData.parentMobile || '',

                        permanent: {
                            selectedCountry: studentData.selectedCountry || '',
                            selectedCountry: studentData.permanentCountry.id || '',
                            selectedState: studentData.selectedState || '',
                            selectedState: studentData.permanentState.id || '',
                            selectedCity: studentData.selectedCity || '',
                            selectedCity: studentData.permanentCity.id || '',
                            permanentTaluka: studentData.permanentTaluka || '',
                            permanentPinCode: studentData.permanentPinCode || '',
                            permanentAddress: studentData.permanentAddress || '',
                        },
                        temporary: {
                            sameAsPermanent: false,
                            country: studentData.currentCountry.id || '',
                            state: studentData.currentState.id || '',
                            city: studentData.currentCity.id || '',
                            currentTaluka: studentData.currentTaluka || '',
                            currentPinCode: studentData.currentPinCode || '',
                            currentAddress: studentData.currentAddress || '',
                        }
                    }));
                } else {
                    console.error('Failed to fetch student details');
                }
            } catch (error) {
                console.error('Error fetching student details:', error);
            }
        };
        fetchStudentDetails();
    }, [token, studentId]);

    const generateResponseBody = () => {
        const body = {
            firstName: formData.firstName,
            middleName: formData.middleName,
            lastName: formData.lastName,
            firstNameUnicode: formData.firstNameUnicode,
            middleNameUnicode: formData.middleNameunicode,
            lastNameUnicode: formData.lastNameunicode,
            nameAsPerAadhaar: formData.nameAsPerAdhar,
            aadhaarCardNo: formData.adharCard,
            abcID: formData.abcid,
            mobileNo: formData.mobile,
            email: formData.email,
            genderId: formData.selectedGender,
            nationalityId: formData.selectedNationality,
            religionId: formData.selectedReligion,
            casteCategoryId: formData.selectedCasteCategory,
            dateOfBirth: formData.dateOfBirth,
            birthPlace: formData.birthPlace,
            maritalStatusId: formData.selectedMaritalstatus,
            bloodGroupId: formData.selectedBloodGroup,
            categoryType: formData.selectedCategoryType,
            socialReservation: formData.socialReservation,
            udiseNo: formData.udiseno,
            inHouse: formData.inhouseStudent,
            exServicemenStudent: formData.exServicemen,
            differentlyAbled: formData.differentlyAbledStudent,
            orphan: formData.areYouOrphanStudent,
            fatherName: formData.fatherName,
            fatherNameUnicode: formData.fatherNameUnicode,
            motherName: formData.MotherName,
            motherNameUnicode: formData.motherNameUnicode,
            familyMembers: formData.totalFamilyMember,
            annualIncome: formData.familyAnnualIncome,
            parentName: formData.ParentName,
            parentMobile: formData.parentMobile,

            permanentCountryId: formData.permanent.selectedCountry || '',
            permanentStateId: formData.permanent.selectedState || '',
            permanentCityId: formData.permanent.selectedCity || '',
            permanentTaluka: formData.permanent.permanentTaluka || '',
            permanentAddress: formData.permanent.permanentAddress || '',
            permanentPinCode: formData.permanent.permanentPinCode || '',

            currentCountryId: formData.temporary.sameAsPermanent
                ? formData.permanent.selectedCountry || ''
                : formData.temporary.country || '',
            currentStateId: formData.temporary.sameAsPermanent
                ? formData.permanent.selectedState || ''
                : formData.temporary.state || '',
            currentCityId: formData.temporary.sameAsPermanent
                ? formData.permanent.selectedCity || ''
                : formData.temporary.city || '',
            currentTaluka: formData.temporary.sameAsPermanent
                ? formData.permanent.permanentTaluka || ''
                : formData.temporary.currentTaluka || '',
            currentAddress: formData.temporary.sameAsPermanent
                ? formData.permanent.permanentAddress || ''
                : formData.temporary.currentAddress || '',
            currentPinCode: formData.temporary.sameAsPermanent
                ? formData.permanent.permanentPinCode || ''
                : formData.temporary.currentPinCode || '',
        };

        return body;
    };

    const validateAddressDetails = (data) => {
        const errors = {};

        if (!data.permanent.selectedCountry) errors["permanent.selectedCountry"] = 'Country is required';
        if (!data.permanent.selectedState) errors["permanent.selectedState"] = 'State is required';
        if (!data.permanent.selectedCity) errors["permanent.selectedCity"] = 'City is required';
        if (!data.permanent.permanentAddress) errors["permanent.permanentAddress"] = 'Address is required';
        if (!data.permanent.permanentPinCode) {
            errors["permanent.permanentPinCode"] = 'Pin Code is required';
        }

        if (!data.temporary.sameAsPermanent) {
            if (!data.temporary.country) errors["temporary.country"] = 'Country is required';
            if (!data.temporary.state) errors["temporary.state"] = 'State is required';
            if (!data.temporary.city) errors["temporary.city"] = 'City is required';
            if (!data.temporary.currentAddress) errors["temporary.currentAddress"] = 'Address is required';
            if (!data.temporary.currentPinCode) {
                errors["temporary.currentPinCode"] = 'Pin Code is required';
            }
        }

        return errors;
    };

    const handleUpdate = async () => {
        const addressErrors = validateAddressDetails(formData);
        setErrors(prev => ({ ...prev, addressDetails: addressErrors }));

        if (Object.keys(addressErrors).length > 0) {
            return;
        }

        const combinedData = generateResponseBody();
        console.log("Update request body:", combinedData);

        try {
            const response = await UpdateStudentDetails(combinedData, token, studentId);
            console.log("Update response:", response);
            if (response.status === 200) {
                alert("Details updated successfully!");
            } else {
                alert("Failed to update details.");
            }
        } catch (error) {
            console.error("Error updating data:", error);
            alert("An error occurred while updating details.");
        }
    };

    const handleSubmit = async () => {
        if (isEditMode) {
            await handleUpdate();
        } else {
            const addressErrors = validateAddressDetails(formData);
            setErrors(prev => ({ ...prev, addressDetails: addressErrors }));

            if (Object.keys(addressErrors).length > 0) {
                return;
            }
            const combinedData = generateResponseBody();
            console.log("Response body:", combinedData);
            try {
                const response = await postStudentDetails(combinedData, token, studentId);
                console.log("Response of post student data:", response);
                if (response.status === 200) {
                    alert("Details saved successfully!");
                    setIsEditMode(true); // Switch to edit mode after successful save
                } else {
                    alert("Failed to save details.");
                }
            } catch (error) {
                console.error("Error submitting data:", error);
                alert("An error occurred while saving details.");
            }
        }
    };

    useEffect(() => {
        const fetchApplications = async () => {
            try {
                const response = await getStudentApplicationByStudent(token, studentId);
                console.log("Fetched Applications:", response.data);
                setApplications(response.data);
            } catch (error) {
                console.error("Error fetching applications:", error);
            }
        };

        fetchApplications();
    }, [token, studentId]);


    const validateStudentDetails = (data) => {
        const errors = {};

        if (!/^[A-Za-z\s]+$/.test(data.firstName)) {
            errors.firstName = 'Only alphabets are allowed';
        }
        if (!data.lastName) {
            errors.lastName = 'Last Name is required';
        } else if (!/^[A-Za-z\s]+$/.test(data.lastName)) {
            errors.lastName = 'Only alphabets are allowed';
        }
        if (!data.lastNameunicode) {
            errors.lastNameunicode = 'Last Name Unicode is required';
        } else if (!/^[A-Za-z\s]+$/.test(data.lastNameunicode)) {
            errors.lastNameunicode = 'Only alphabets are allowed';
        }
        if (!data.lastNameunicode) errors.lastNameunicode = 'Last Name Unicode is required';
        if (!data.abcid) errors.abcid = 'ABC ID is required';
        if (!data.selectedNationality) errors.selectedNationality = 'Nationality is required';
        if (!data.mobile) {
            errors.mobile = 'Mobile No. is required';
        } else if (!/^\d{10}$/.test(data.mobile)) {
            errors.mobile = 'Mobile No. must be 10 digits';
        }
        if (!data.selectedReligion) errors.selectedReligion = 'Religion is required';
        if (!data.selectedMaritalstatus) errors.selectedMaritalstatus = 'Marital Status is required';
        if (!data.nameAsPerAdhar) {
            errors.nameAsPerAdhar = 'Name as per Aadhar is required';
        } else if (!/^[A-Za-z\s]+$/.test(data.nameAsPerAdhar)) {
            errors.nameAsPerAdhar = 'Only alphabets are allowed';
        }
        if (!data.email) {
            errors.email = 'Email is required';
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
            errors.email = 'Invalid email format';
        }
        if (!data.adharCard) {
            errors.adharCard = 'Aadhar Card No. is required';
        } else if (!/^\d{12}$/.test(data.adharCard)) {
            errors.adharCard = 'Aadhar must be 12 digits';
        }
        if (!data.selectedGender) errors.selectedGender = 'Gender is required';
        if (!data.dateOfBirth) errors.dateOfBirth = 'Date of Birth is required';
        if (!data.selectedCasteCategory) errors.selectedCasteCategory = 'Caste Category is required';
        if (!data.selectedBloodGroup) errors.selectedBloodGroup = 'Blood Group is required';

        // Family details validation
        if (!data.fatherName) {
            errors.fatherName = 'Father Name is required';
        } else if (!/^[A-Za-z\s]+$/.test(data.fatherName)) {
            errors.fatherName = 'Only alphabets are allowed';
        }
        if (!data.fatherNameUnicode) {
            errors.fatherNameUnicode = 'Father Name Unicode is required';
        } else if (!/^[A-Za-z\s]+$/.test(data.fatherNameUnicode)) {
            errors.fatherNameUnicode = 'Only alphabets are allowed';
        }
        if (!data.MotherName) {
            errors.MotherName = 'Mother Name is required';
        } else if (!/^[A-Za-z\s]+$/.test(data.MotherName)) {
            errors.MotherName = 'Only alphabets are allowed';
        }
        if (!data.motherNameUnicode) {
            errors.motherNameUnicode = 'Mother Name Unicode is required';
        } else if (!/^[A-Za-z\s]+$/.test(data.motherNameUnicode)) {
            errors.motherNameUnicode = 'Only alphabets are allowed';
        }
        if (!data.totalFamilyMember) {
            errors.totalFamilyMember = 'Total Family Members is required';
        } else if (!/^\d+$/.test(data.totalFamilyMember)) {
            errors.totalFamilyMember = 'Only numbers are allowed';
        } else if (parseInt(data.totalFamilyMember) <= 0) {
            errors.totalFamilyMember = 'Must be greater than 0';
        }
        if (!data.familyAnnualIncome) {
            errors.familyAnnualIncome = 'Family Annual Income is required';
        } else {
           const numericValue = String(data.familyAnnualIncome).replace(/,/g, '');
            if (!/^\d+$/.test(numericValue)) {
                errors.familyAnnualIncome = 'Only numbers are allowed';
            } else if (parseInt(numericValue) <= 0) {
                errors.familyAnnualIncome = 'Must be greater than 0';
            }
        }

        return errors;
    };

    const handleNext = async () => {
        if (activeStep === 0) {
            const studentErrors = validateStudentDetails(formData);
            setErrors(prev => ({ ...prev, studentDetails: studentErrors }));

            if (Object.keys(studentErrors).length > 0) {
                return; // Don't proceed if there are errors
            }
        }


        if (activeStep === 1) { // Address tab validation
            const addressErrors = validateAddressDetails(formData);
            setErrors(prev => ({ ...prev, addressDetails: addressErrors }));

            if (Object.keys(addressErrors).length > 0) {
                // Show toast for each address error
                Object.values(addressErrors).forEach(error => {
                    if (error) toast.error(error);
                });
                return;
            }
        }

        if (activeStep === 3) { // Course Choice validation
            if (!formData.selectedCourse) {
                setErrors(prev => ({
                    ...prev,
                    courseDetails: {
                        selectedCourse: 'Course selection is required'
                    }
                }));
                // toast.error('Please select a course');
                return;
            }
        }

        if (activeStep === steps.length - 1) {
            console.log("Is terms accepted:", isTermsAccepted);
            if (!isTermsAccepted) {
                alert("Please accept the terms and conditions before proceeding.");
                return;
            }
            try {
                const studentIdNumber = Number(studentId);
                const courseIdNumber = Number(formData.selectedCourse);
                const response = await createStudentApplication(studentIdNumber, courseIdNumber, token);
                console.log("created application response", response);
                if (response.status === 200) {
                    alert("Application created successfully!");
                    //setIsApplicationCreated(true);
                    const updatedApplications = await getStudentApplicationByStudent(token, studentId);
                    setApplications(updatedApplications.data);
                    setCompletedSteps([0, 1, 2]);
                    // Automatically navigate to "Course Choice" tab
                    setActiveStep(steps.findIndex((step) => step.label === "Course Choice"));
                } else {
                    alert("Failed to create application.");
                }
            } catch (error) {
                console.error("Error creating application:", error);
                if (error.response) {
                    console.error("Error response data:", error.response.data);
                    console.error("Error response status:", error.response.status);
                    alert(`Error: ${error.response.data?.message || 'An error occurred while creating the application.'}`);
                } else {
                    alert("An unknown error occurred.");
                }
            }
        } else {
            setActiveStep((prev) => prev + 1);
        }
    };

    const handleBack = () => {
        const updatedCompletedSteps = [...completedSteps];
        updatedCompletedSteps.pop(); // Remove the last completed step
        setCompletedSteps(updatedCompletedSteps);
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };
    const handleStepClick = (stepIndex) => {
        if (completedSteps.includes(stepIndex) || stepIndex === activeStep) {
            return;
        }
        setActiveStep(stepIndex);
    };

    const fetchAssignedTabs = async (courseId) => {
        try {
            const response = await getAssignedTabs(courseId, token);
            console.log("Assign tabs for Selected Course are:", response.data)
            const assignedTabs = response.data.map((tab) => ({
                label: tab.tabs,
                icon: getIconForTab(tab.tabs), // Function to get icons dynamically
            }));
            // Insert the dynamic tabs between 'Course Choice' and 'Confirm Registration'
            setSteps((prevSteps) => [
                ...prevSteps.slice(0, 4),
                ...assignedTabs,
                { label: 'Confirm Registration', icon: <ThumbUpAltIcon /> },
            ]);
        } catch (error) {
            console.error("Error fetching assigned tabs:", error);
        }
    };

    const fetchAssignedDocuments = async (courseId) => {
        try {
            const response = await getAssignedDocuments(courseId, token);
            console.log("Assigned documents for selected course:", response.data);
            setDocuments(response.data);
        } catch (error) {
            console.error("Error fetching assigned documents:", error);
        }
    };

    const fetchRegistrationFees = async (courseId) => {
        try {
            const response = await getRegisterFees(courseId, token);
            console.log("RegistrationFees:", response.data)
            setRegistrationFees(response.data)
        } catch (error) {
            console.error("Error fetching fees:", error);
        }
    };
    useEffect(() => {
        if (formData.selectedCourse) {
            fetchAssignedTabs(formData.selectedCourse);
            fetchAssignedDocuments(formData.selectedCourse);
            fetchRegistrationFees(formData.selectedCourse);
        }
    }, [formData.selectedCourse]);

    return (
        <>
            <Box className="mt-2">
                <Box sx={{ width: '100%' }}>
                    <Stepper activeStep={activeStep} alternativeLabel>
                        {steps.map((step, index) => (
                            <Step key={index} completed={completedSteps.includes(index)} onClick={() => handleStepClick(index)}>
                                <StepLabel
                                    icon={
                                        completedSteps.includes(index) ? (
                                            <CheckCircleIcon style={{ color: 'green' }} />
                                        ) : (
                                            step.icon
                                        )
                                    }
                                >
                                    {step.label}
                                </StepLabel>
                            </Step>
                        ))}
                    </Stepper>
                    <Box>
                        {activeStep === 0 && <StudentDetails formData={formData} setFormData={setFormData} handleChange={handleChange} errors={errors.studentDetails} />}
                        {activeStep === 1 && <AddressDetails formData={formData} setFormData={setFormData}
                            onSubmit={handleSubmit}
                            handleChange={handleChange} errors={errors.addressDetails} setErrors={setErrors} isEditMode={isEditMode} />}
                        {activeStep === 2 && <PhotoSignDetails />}
                        {activeStep === 3 && <CouresChoiceDetails formData={formData} setFormData={setFormData} handleChange={handleChange}
                            closedCourses={closedCourses} errors={errors}
                            setErrors={setErrors} />}
                        {steps.some((step) => step.label === 'Last Qualifying') && activeStep === steps.findIndex((step) => step.label === 'Last Qualifying') &&
                            <LastQualifyingExam formData={formData} setFormData={setFormData} handleChange={handleChange} steps={steps} courseId={formData.selectedCourse} />}
                        {steps.some((step) => step.label === 'Document') && activeStep === steps.findIndex((step) => step.label === 'Document') &&
                            <DocumentDetails documents={documents} courseId={formData.selectedCourse} />}
                        {steps.some((step) => step.label === 'Subject') && activeStep === steps.findIndex((step) => step.label === 'Subject') &&
                            <SubjectDetails courseId={formData.selectedCourse} />}
                        {steps.some((step) => step.label === 'Payment') && activeStep === steps.findIndex((step) => step.label === 'Payment') &&
                            <PaymentDetails registrationFees={registrationFees.fees} />}
                        {activeStep === steps.length - 1 && (
                            <ConfirmRegistration
                                isTermsAccepted={isTermsAccepted}
                                setIsTermsAccepted={setIsTermsAccepted}
                                applications={applications}
                            />
                        )}
                    </Box>
                    <Box sx={{ display: "flex", justifyContent: "space-evenly", marginBottom: "20px" }}>
                        <Button className='mt-4' disabled={activeStep === 0} onClick={handleBack} style={{ backgroundColor: "#62729f", color: "#fff", marginRight: "20px" }}>
                            Back
                        </Button>
                        <Button className='mt-4' onClick={handleNext} style={{ backgroundColor: "#6e48aa", color: "#fff" }}>
                            {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                        </Button>

                    </Box>

                </Box>
                <Row className='mt-4' style={{ padding: "0px 20px" }}>
                    <Col >
                        {activeStep === steps.length - 1 && <PrintApplication applications={applications} />}
                    </Col>
                </Row>
            </Box>
        </>
    );
}

const getIconForTab = (label) => {
    switch (label) {
        case 'Last Qualifying': return <LocalLibraryIcon />;
        case 'Document': return <DescriptionIcon />;
        case 'Subject': return <SubjectIcon />;
        case 'Payment': return <AttachMoneyIcon />;
    }
};

export default StudentDashboard;